(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSActividadDeleteController',SSActividadDeleteController);

    SSActividadDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSActividad'];

    function SSActividadDeleteController($uibModalInstance, entity, SSActividad) {
        var vm = this;

        vm.sSActividad = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSActividad.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
